import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/relatorios/controle-adesao/ControleAdesoesApiClient'
import { DownloadFile } from '@/core/utils'

export default {
	async [actionTypes.RELATORIOS.CONTROLE_ADESOES.BUSCAR_ATAS](context, objParam) {
		const { data } = await api.buscarAtas(objParam)
		return data
	},
	async [actionTypes.RELATORIOS.CONTROLE_ADESOES.GERAR_RELATORIO](context, idAta) {
		const response = await api.gerarRelatorioAdesao(idAta)

		if (response.data.byteLength === 0) return 0

		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
}
